import CardContent from "../CardContent/CardContent";

function PokemonCard({ pokemonName, pokemon, onClick }) {
  const label = pokemon?.name || pokemonName || "pokemon";

  return (
    <button
      aria-label={`Open ${label} details`}
      className="card card-button"
      type="button"
      onClick={onClick}
    >
      <CardContent pokemonName={pokemonName} pokemon={pokemon} />
    </button>
  );
}

export default PokemonCard;
